import { appConstants } from '../_constants';

export function setSidebarVisibility(visible) {
    return {
        type: appConstants.TOGGLE_SIDEBAR_VISIBLE,
        payload: visible
    };
}